export default [
  {
    path: '/admin/system/dictionary/index',
    name: 'M020014',
    component: () =>
      import('@/views/admin/system/dictionary/DictionaryIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/system/helper-doc/index',
    name: 'M020006',
    component: () => import('@/views/admin/system/help-doc/HelpDocIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/system/sensitive-word/index',
    name: 'M020024',
    component: () =>
      import('@/views/admin/system/sensitive-word/WordIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/system/security-config/index',
    name: 'M020027',
    component: () =>
      import('@/views/admin/system/security-config/SecurityIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/system/common-service/index',
    name: 'M020037',
    component: () =>
      import('@/views/admin/system/common-service/ServiceIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/system/system-reach/index',
    name: 'M020038',
    component: () => import('@/views/admin/system/system-reach/ReachIndex.vue'),
    meta: { layout: 'admin' },
  },
];
